import {useEffect, useRef} from 'react'
import {XMarkIcon} from '@heroicons/react/16/solid'
import {createPortal} from 'react-dom';
import {useVideoModal} from './VideoModalContext';

export default function VideoModal() {
  const ref = useRef()
  const {item, setItem} = useVideoModal()

  useEffect(() => {
    if (item) {
      document.body.classList.add('overflow-hidden');
      ref.current?.showModal()
    } else {
      document.body.classList.remove('overflow-hidden');
      ref.current?.close()
    }
  }, [item])

  const closeModal = () => {
    setItem(null)
  }

  return (
    createPortal(
      <dialog ref={ref} className="video-dialog" closedby="any" onCancel={closeModal}>
        <div className="video-dialog__container">
          <div className="video-dialog__header">
            <button className="close-button keep-in-pure-printable" type="button" aria-label={Drupal.t('Close dialog')} onClick={closeModal}>
              <XMarkIcon className="size-4" />
              <span className="sr-only">{Drupal.t('Close dialog')}</span>
            </button>
          </div>
          <div className="video-dialog__body">
            {item && item.video && (
              <video controls={true} autoPlay={true} loop={false} muted={false}>
                {item.video.sources.map((source, i) => (
                  <source src={source.src} type={source.type} key={i}/>
                ))}
              </video>
            )}
          </div>
        </div>
      </dialog>,
      document.body,
    )
  )
}
